import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getRedoSuppliesOrder = {
  name: "getRedoSuppliesOrder" as const,
  input: z.object({ orderId: z.string() }),
  output: z.object({
    order: z.object({ _id: zExt.objectId() }).catchall(z.any()),
  }),
};
